import { CallHandler, ExecutionContext, NestInterceptor } from '@nestjs/common';
import { stat, unlink } from 'fs/promises';
import { Observable, switchMap } from 'rxjs';

export class AutoReapInterceptor implements NestInterceptor {
  public intercept(context: ExecutionContext, next: CallHandler): Observable<any> {
    const queue = [] as any[];
    const request = context.switchToHttp().getRequest();
    if (request.file) queue.push(request.file);
    if (request.files) queue.push(...(Array.isArray(request.files) ? request.files : Object.values(request.files)));
    return next.handle().pipe(
      switchMap(async (data) => {
        for (const file of queue) {
          try {
            const stats = await stat(file.path);
            if (!stats.isFile()) return;
            await unlink(file.path);
          } catch {
            // KEEP EMPTY
          }
        }
        return data;
      })
    );
  }
}
